import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useRecipePosterData } from "./hooks/useRecipePosterData.js";
import { usePosterExport } from "./hooks/usePosterExport.js";
import { imageToDataUrl } from "./utils.js";
import { PosterCreatorLayout } from "./PosterCreatorLayout.jsx";
import { UnauthorizedView } from "./UnauthorizedView.jsx";

const getLogoUrl = () => {
  if (typeof window === "undefined") return "";
  const base = process.env.PUBLIC_URL || "";
  return `${window.location.origin}${base}/logojes.png`;
};

const RecipePosterCreator = ({ user, token }) => {
  const navigate = useNavigate();
  const posterRef = useRef(null);

  const [selectedRecipe, setSelectedRecipe] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState("amber");
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState(null);
  const [logoDataUrl, setLogoDataUrl] = useState(null);

  useEffect(() => {
    const url = getLogoUrl();
    if (!url) return;
    imageToDataUrl(url).then(setLogoDataUrl);
  }, []);

  const { recipes, loading, preloadedImageUrl } = useRecipePosterData(
    token,
    selectedRecipe,
    setSelectedRecipe,
    setError,
  );

  const { handleDownloadPng, handleDownloadPdf } = usePosterExport({
    posterRef,
    selectedRecipe,
    selectedTemplate,
    user,
    preloadedImageUrl,
    logoDataUrl,
    setDownloading,
    setError,
  });

  if (!user) return <UnauthorizedView />;

  return (
    <PosterCreatorLayout
      navigate={navigate}
      error={error}
      downloading={downloading}
      recipes={recipes}
      loading={loading}
      selectedRecipe={selectedRecipe}
      setSelectedRecipe={setSelectedRecipe}
      selectedTemplate={selectedTemplate}
      setSelectedTemplate={setSelectedTemplate}
      handleDownloadPng={handleDownloadPng}
      handleDownloadPdf={handleDownloadPdf}
      posterRef={posterRef}
      preloadedImageUrl={preloadedImageUrl}
      user={user}
    />
  );
};

export default RecipePosterCreator;
